export const getCookie = (cname) => {
  var name = cname + "="
  var decodedCookie = decodeURIComponent(document.cookie)
  var ca = decodedCookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export const renumberLaceyActContainers = (containers) => (
  containers.map((container, index) => {
    let containerKeyInfo = container.key.split('.')
    containerKeyInfo[1] = index + 1
    container.key = containerKeyInfo.join('.')
    return container
  })
)

export const renumberPGAItems = (items) => (
  items.map((item, index) => {
    for (let type in item) {
      let itemKeyInfo = item[type].key.split('.')
      itemKeyInfo[1] = index + 1
      item[type].key = itemKeyInfo.join('.')
    }
    return item
  })
)


// Formats flat HTS with appropiate '.'
export const formatHTS = hts => {
  if (hts !== undefined) {
    let newHts = hts.replace(/[.]/g, '')
    if (newHts.length < 5) return hts
    if (newHts.length >= 5 && newHts.length <= 6) {
      newHts = insertIntoString(newHts, 4, '.')
      return newHts
    }
    if (newHts.length >= 7 && newHts.length <= 8) {
      newHts = insertIntoString(newHts, 4, '.')
      newHts = insertIntoString(newHts, 7, '.')
      return newHts
    }
    if (newHts.length >= 9) {
      newHts = insertIntoString(newHts, 4, '.')
      newHts = insertIntoString(newHts, 7, '.')
      newHts = insertIntoString(newHts, 10, '.')
      return newHts
    }
  }
}

export const formatHTSTree = hts => {
  if (hts !== undefined) {
    let newHts = hts.replace(/[.]/g, '')
    if (newHts.length <= 3) return newHts.slice(0, 2)
    if (newHts.length <= 5 && newHts.length <= 6) {
      return newHts.slice(0, 4)
    }
    else {
      let cutHTS = newHts.slice(0, 6)
      cutHTS = insertIntoString(cutHTS, 4, '.')
      return cutHTS
    }
  }
}

export const insertIntoString = (str, index, value) => {
  return str.substr(0, index) + value + str.substr(index)
}

export const sleep = (sleepTime) => new Promise(resolve => setTimeout(resolve, sleepTime));